import React, { useState, useEffect, useRef, useContext } from "react";
import "./New_Highlight.css";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import { NewUpdates } from "../../../utils/apis/subsidy-policy/SubsidyPolicy";
import { IDS } from "../../../utils/common";
import { Context } from "../../../utils/context";

const New_Highlight = () => {
  const navigate = useNavigate();
  const notices = [
    {
      id: 1,
      img: "/assets/images/subsidy/book.png",
      date: "08 FEB",
      title: "General Notice:",
      description:
        "Public Notice -Guidelines On Inverter Communication Devices, Dataloggers and Remote Monitoring Systems (RMS) for communication with the centralised IoT SCADA platform under PMSG: MBY",
    },
    {
      id: 2,
      img: "/assets/images/subsidy/set.png",
      date: "08 FEB",
      title: "General Notice:",
      description:
        "Public Notice -Guidelines On Inverter Communication Devices, Dataloggers and Remote Monitoring Systems (RMS) for communication with the centralised IoT SCADA platform under PMSG: MBY",
    },
    {
      id: 3,
      img: "/assets/images/subsidy/book.png",
      date: "08 FEB",
      title: "General Notice:",
      description:
        "Public Notice -Guidelines On Inverter Communication Devices, Dataloggers and Remote Monitoring Systems (RMS) for communication with the centralised IoT SCADA platform under PMSG: MBY",
    },
    {
      id: 4,
      img: "/assets/images/subsidy/book.png",
      date: "08 FEB",
      title: "General Notice:",
      description:
        "Public Notice -Guidelines On Inverter Communication Devices, Dataloggers and Remote Monitoring Systems (RMS) for communication with the centralised IoT SCADA platform under PMSG: MBY",
    },
    {
      id: 5,
      img: "/assets/images/subsidy/book.png",
      date: "08 FEB",
      title: "General Notice:",
      description:
        "Public Notice -Guidelines On Inverter Communication Devices, Dataloggers and Remote Monitoring Systems (RMS) for communication with the centralised IoT SCADA platform under PMSG: MBY",
    },
  ];

  const { IMG_URL } = useContext(Context);

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [newupdate, setNewUpdate] = useState([]);

  const getNewUpdate = async () => {
    const res = await NewUpdates();

    if (res?.success) {
      setNewUpdate(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getNewUpdate();
  }, []);

  return (
    <section className="New_Highlight">
      <div className="container-fluid">
        <div className="New_Highlight_header_holder">
          <h5 className="New_Highlight_title">New Updates & Highlights</h5>
          <p className="New_Highlight_subtitle">
            Latest updates, announcements, and important information at a
            glance.
          </p>
        </div>

        <div className="New_Highlight_banner_holder">
          <div className="New_Highlight_banner_div">
            <img
              src="/assets/images/subsidy/subsidy-banner.png"
              alt="banner"
              className="subsidy_banner"
            />
          </div>

          <div className="notice_section">
            <div className="container p-0">
              <Swiper
                modules={[Navigation, Pagination]}
                navigation={true}
                pagination={{ clickable: true }}
                spaceBetween={20}
                slidesPerView={4}
                breakpoints={{
                  1200: { slidesPerView: 4 },
                  992: { slidesPerView: 3 },
                  768: { slidesPerView: 2.2 },
                  575: { slidesPerView: 2 },
                  0: { slidesPerView: 1.2 },
                }}
                className="notice_swiper"
              >
                {newupdate.map((item) => (
                  <SwiperSlide key={item.id}>
                    <div className="notice_card">
                      <div className="notice_date">
                        - Posted on{" "}
                        {new Date(item.createdAt).toLocaleDateString("en-GB", {
                          day: "numeric",
                          month: "short",
                          year: "numeric",
                        })}
                      </div>

                      <div className="notice_icon">
                        <img
                          src={IDS?.IMG_URL + item?.image}
                          className="notice_img"
                        />
                      </div>

                      <h6 className="notice_title">{item.name}</h6>

                      <p className="notice_text">
                        {htmlToReactParser.parse(item.description)}
                      </p>
                    </div>
                  </SwiperSlide>
                ))}

                <SwiperSlide>
                  <div
                    className="view_all_card"
                    onClick={() => navigate("/new-highlight-inner-page")}
                  >
                    <span>View All</span>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default New_Highlight;
